import { Component } from '@builder.io/sdk';

// Content is sourced from the `landing-search-page` data model (fetched on the server
// and passed in as props), so the component exposes no editable inputs in Builder.
export const config: Component = {
    name: 'Footer Hook (Landing Search)',
    inputs: [],
};
